<template>
  <div class="m-content">
    <HeaderBox :id="id"/>
    <div class="report-content">
      <div class="report-area">
        <p class="know-text">答对：<span class="know-num">{{result.rightNum}}</span>题</p>
        <p class="know-text">你打败了<span class="know-percent">{{result.exceedPercent}}%</span>的闯关者</p>
      </div>
      <div class="report-area">
        <p class="user-title">排行榜</p>
        <div class="user-list">
          <div class="user-text" v-for="(list,index) in result.listUserResult" >
            <p class="left-side">{{list.user.studentCollege}}{{list.user.studentName}}</p>
            <p class="right-side">
              <i class="iconfont icon-check"></i>
              {{list.rightNum}}题
            </p>
          </div>
        </div>
      </div>
    </div>
   <FootBox :id="id"/>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'

export default {
  props: {
    id: Number
  },
  name: 'KnowlegeReport',
  components: {
    HeaderBox,
    FootBox
  },
  data() {
    return {
      result:''
    };
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created: function () {
    setWechatTitle('生涯驿站-职业能力知多少')
    this.getReport()
  },
  methods:{
    // 获取报告信息将值传给data
    getReport(result){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosKnowledgeReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            const result = response.data.data
            if(result){
              this.result=result.cosKnowledge
              let text=''
              if(this.result.rightNum>=8){
                text = '答对了'+this.result.rightNum+'题，Excellent'
              }else{
                text = '已经打败了'+this.result.exceedPercent+'%的闯关者'
              }
               store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
             }
          }
        })
        .catch((error)=>{
          console.log(error);
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .icon-check
    color:#24C130
    font-size:0.36rem
    font-weight:bold
</style>
